// Sprint 11 A2: AI Insights section

export function BriefingAiInsights({ insights }: { insights: string[] }) {
  if (insights.length === 0) return null;

  return (
    <div>
      <h2 className="text-sm font-bold text-[var(--color-muted-foreground)] uppercase tracking-wide mb-3">AI Insights</h2>
      <div className="space-y-2">
        {insights.map((insight, i) => (
          <div key={i} className="text-xs text-[var(--color-foreground)] bg-[var(--color-primary)]/5 dark:bg-[var(--color-primary)]/20 rounded-lg px-3 py-2">
            <span className="text-[var(--color-primary)] font-medium mr-1">💡</span>
            {insight}
          </div>
        ))}
      </div>
    </div>
  );
}
